import { Draft, PayloadAction } from '@reduxjs/toolkit';

import IGetDocumentsInterventionResponse from 'services/httpClient/responses/intervention/IGetDocumentsInterventionResponse';

import { IInterventionData } from '../../initialState';

interface IGetDocumentsInterventionsSuccessWithDataAction {
  documents: IGetDocumentsInterventionResponse[];
}
const invoiceTypes = ['document_invoice', 'insurer', 'document_quote'];
const mandateTypes = ['document_mandate'];
const reportTypes = ['report'];

function getDocumentsSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetDocumentsInterventionsSuccessWithDataAction>,
) {
  draft.getDocuments.config.isLoading = false;
  draft.getDocuments.availableDocuments = action.payload.documents.map(
    doc => doc.file_type,
  );
  draft.getDocuments.documents.invoice = action.payload.documents
    .filter(document => invoiceTypes.includes(document.file_type))
    .map(document => {
      return {
        created_at: document.created_at,
        document_id: document.document_id,
        document_url: document.document_url,
        file_name: document.file_name,
        file_type: document.file_type,
        id: document.id,
        intervention_id: document.intervention_id,
        mime_type: document.mime_type,
        temporary_url: document.temporary_url,
      };
    });
  draft.getDocuments.documents.photosDamage = action.payload.documents
    .filter(document => document.file_type === 'photo_damage')
    .map(document => {
      return {
        created_at: document.created_at,
        document_id: document.document_id,
        document_url: document.document_url,
        file_name: document.file_name,
        file_type: document.file_type,
        id: document.id,
        intervention_id: document.intervention_id,
        mime_type: document.mime_type,
        temporary_url: document.temporary_url,
      };
    });
  draft.getDocuments.documents.photosRepair = action.payload.documents
    .filter(document => document.file_type === 'photo_post_repair')
    .map(document => {
      return {
        created_at: document.created_at,
        document_id: document.document_id,
        document_url: document.document_url,
        file_name: document.file_name,
        file_type: document.file_type,
        id: document.id,
        intervention_id: document.intervention_id,
        mime_type: document.mime_type,
        temporary_url: document.temporary_url,
      };
    });
  draft.getDocuments.documents.mandate = action.payload.documents
    .filter(document => mandateTypes.includes(document.file_type))
    .map(document => {
      return {
        created_at: document.created_at,
        document_id: document.document_id,
        document_url: document.document_url,
        file_name: document.file_name,
        file_type: document.file_type,
        id: document.id,
        intervention_id: document.intervention_id,
        mime_type: document.mime_type,
        temporary_url: document.temporary_url,
      };
    });
  draft.getDocuments.documents.report = action.payload.documents
    .filter(document => reportTypes.includes(document.file_type))
    .map(document => {
      return {
        created_at: document.created_at,
        document_id: document.document_id,
        document_url: document.document_url,
        file_name: document.file_name,
        file_type: document.file_type,
        id: document.id,
        intervention_id: document.intervention_id,
        mime_type: document.mime_type,
        temporary_url: document.temporary_url,
      };
    });
}

export default getDocumentsSuccess;
